/**
 * Project API Service
 */

import { apiClient } from './client'
import type {
  ProjectCreate,
  ProjectUpdate,
  ProjectResponse,
  ProjectListResponse,
  ProjectFilterParams,
  ProjectTransition,
} from '@/types/api'

/**
 * Get paginated list of projects with optional filters
 */
export async function getProjects(params?: ProjectFilterParams): Promise<ProjectListResponse> {
  return apiClient.get<ProjectListResponse>('/projects', { params })
}

/**
 * Get a single project by ID
 */
export async function getProject(id: string): Promise<ProjectResponse> {
  return apiClient.get<ProjectResponse>(`/projects/${id}`)
}

/**
 * Create a new project
 */
export async function createProject(data: ProjectCreate): Promise<ProjectResponse> {
  return apiClient.post<ProjectResponse>('/projects', data)
}

/**
 * Update an existing project
 */
export async function updateProject(id: string, data: ProjectUpdate): Promise<ProjectResponse> {
  return apiClient.put<ProjectResponse>(`/projects/${id}`, data)
}

/**
 * Delete a project (admin only)
 */
export async function deleteProject(id: string): Promise<void> {
  return apiClient.delete(`/projects/${id}`)
}

/**
 * Transition project to a new status
 */
export async function transitionProject(id: string, data: ProjectTransition): Promise<ProjectResponse> {
  return apiClient.post<ProjectResponse>(`/projects/${id}/transition`, data)
}

/**
 * Get all projects for a lead
 */
export async function getLeadProjects(leadId: string): Promise<ProjectListResponse> {
  return apiClient.get<ProjectListResponse>(`/leads/${leadId}/projects`)
}

export const projectService = {
  getProjects,
  getProject,
  createProject,
  updateProject,
  deleteProject,
  transitionProject,
  getLeadProjects,
}
